import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  height: "224",
  viewBox: "0 0 260 227",
  focusable: "false",
  role: "presentation"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  fill: "none",
  "clip-path": "url(#carousel-1_svg__a)"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#efefef",
    d: "M27.6 175.17s20.49 29.58 58.46 30.14 61.59-25 87.83-39.66c13.74-7.67 30.49-7.1 45.49-11.73 47.92-14.79 59.75-75.9 35.56-107.27-23.38-30.3-64-38.8-100.63-38.59C87.32 8.46-3.42 42.64 7.27 123.27a119.33 119.33 0 0 0 20.33 51.9z"
  }),
  /*#__PURE__*/_createElementVNode("mask", {
    id: "carousel-1_svg__b",
    width: "261",
    height: "198",
    x: "7",
    y: "5",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#efefef",
      d: "M28.48 172.68s20.49 29.58 58.46 30.14 61.58-25 87.82-39.65c13.75-7.67 30.5-7.1 45.5-11.73 47.92-14.8 59.74-75.9 35.56-107.28-23.38-30.3-64-38.8-100.63-38.58C88.2 5.96-2.54 40.15 8.14 120.78a119.33 119.33 0 0 0 20.34 51.9z"
    })
  ]),
  /*#__PURE__*/_createElementVNode("g", { mask: "url(#carousel-1_svg__b)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M322.76 162.65s-2.35-89.86-34.58-99.94c-32.86-10.27-67.96-9.4-102-7.88-32.1 1.44-64.45.56-96.47 2.65-35.26 2.3-48.32 18.26-56.08 50.4a263.75 263.75 0 0 0-7.05 54.77l-7.86 23.25h311.9l-7.86-23.25z",
      style: {"fill":"#fff","stroke":"#263238","stroke-linejoin":"round"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M53.28 173.5v-20.14s-.78-14.73-18.07-16.27-64.42 34.86-63.63 42.62 9.42 62.74 14.93 65.06 19.63 13.2 32.21 7 34.56-78.27 34.56-78.27z",
      style: {"fill":"#fff","stroke":"#263238","stroke-linejoin":"round"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M116.9 158.5s16.33-2.07 27.21 1.65 11.74 20.24 11.32 34.3-5.86 72.28-5.86 80.55 0 16.52-3.36 23.13-12.98 9.5-17.18 10.33-5.44-.83-5.44-.83-5.03.41-5.03-2.07 4.62-2.48 7.13-4.96 8.37-13.2 9.63-19.4a145.87 145.87 0 0 0 2.1-19.02c.41-6.2-3.77-33.04-6.7-47.1s-2.95-16.1-5.46-26.02-8.8-22.71-8.37-30.56z",
      style: {"fill":"#f8eecd","stroke":"#263238","stroke-linejoin":"round"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M72.9 201.88s19.68-2.07 33.94-7.03 21.78-7.44 24.3-17.35-2.52-18.18-18.02-19-37.7.82-44.42 15.28-5.44 23.14 4.2 28.1z",
      style: {"fill":"#f8eecd","stroke":"#263238","stroke-linejoin":"round"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M114.4 74.31s-18.72 6.92-23.88 8.3-11.71 7.44-13.58 15.7-2.8 43.88-2.8 43.88l-21.08 6.01c-3.75.93-4.23 9.24-4.23 9.24-.23 1.44-.7 2.85-1.4 4.15l-.93 1.39s-3.28-1.4 18.74 3.23 57.6 1.85 57.6 1.85 5.15.46 6.56-6 2.8-15.7 4.67-18.48 3.77-5.54 3.77-13.86 5.16-31.86 4.69-40.18-7.96-13.85-16.34-15.23-11.79 0-11.79 0z",
      style: {"fill":"#fff"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M114.4 74.31s-18.72 6.92-23.88 8.3-11.71 7.44-13.58 15.7-2.8 43.88-2.8 43.88l-21.08 6.01c-3.75.93-4.23 9.24-4.23 9.24a13.5 13.5 0 0 1-1.4 4.15l-.93 1.39s-3.28-1.4 18.74 3.23 57.6 1.85 57.6 1.85 5.15.46 6.56-6 2.8-15.7 4.67-18.48 3.77-5.54 3.77-13.86 5.16-31.86 4.69-40.18-7.96-13.85-16.34-15.23-11.79 0-11.79 0z",
      style: {"stroke":"#263238","stroke-linejoin":"round"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M78.43 155.27s-13.92-1.1-20.1-5.43",
      style: {"stroke-linecap":"round","stroke":"#263238","stroke-linejoin":"round"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M122.84 68.35s-7.96-.92-10.31 3.23a30.68 30.68 0 0 0-4.67 14.78c-.48 6.93-.95 18.48-.95 18.48l14.52-6.93 15.92 7.43s-4.2-16.1-5.15-24.47-4.21-13.49-9.36-12.52z",
      style: {"fill":"#fff","stroke":"#263238","stroke-linejoin":"round"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#263238",
      d: "M126.58 69.69a43.06 43.06 0 0 1-8.9-20.79c-1.4-12 3.28-20.78 11.72-25.39s28.1-9.24 35.59-6.93 17.8 20.79 20.6 30.48-.93 29.56-1.87 35.56.94 30.98 3.28 44.8-5.16 31.4-19.64 35.55-29.5 0-33.25-10.16c-2.75-7.43-1.87-25.4 1.4-37.86s3.29-31.4 3.29-36.94-12.22-8.32-12.22-8.32z",
      style: {"stroke":"#263238","stroke-linejoin":"round"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      stroke: "#fff",
      d: "M152.91 40.24s3.77 4.96-10.05 3.3-20.01-4.96-21.68.4m-.32-4.1s0-9.9 9.6-9.9 17.78 4 21.26 2.47m9.95 7.44a26.86 26.86 0 0 0 10.06 11.51c7.54 4.96 12.97 17.24 12.5 24.25m-12.55-14.8a234.25 234.25 0 0 0 3.77 28.36c3.33 18.5 6.28 48.1-2.09 60.84s-16.68 13.98-24.18 9.46m21.67-90.45s.41 60.85-9.18 69.89-25.85 4.52-23.77-23.02",
      style: {"stroke-linecap":"round","stroke-linejoin":"round"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M127.52 56.3s-2.35 5.53-4.68 12-5.62 11.08-5.62 17.55 0 19.4 3.28 18.94 14.52-22.63 15.92-23.55-4.68-12-4.68-17.55a7.83 7.83 0 0 0-4.22-7.4z",
      style: {"fill":"#fff"}
    }),
    /*#__PURE__*/_createElementVNode("use", {
      "xlink:href": "#carousel-1_svg__c",
      style: {"fill":"#f8eecd"}
    }),
    /*#__PURE__*/_createElementVNode("use", {
      "xlink:href": "#carousel-1_svg__c",
      opacity: ".5",
      style: {"fill":"#fff"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M127.52 56.3s-2.35 5.53-4.68 12-5.62 11.08-5.62 17.55 0 19.4 3.28 18.94 14.52-22.63 15.92-23.55-4.68-12-4.68-17.55a7.83 7.83 0 0 0-4.22-7.4z",
      style: {"stroke":"#263238","stroke-linejoin":"round"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M81.27 154.78s-28.07 1.1-34.77 8.2-11.73 24.78-1.68 35.18 25.14 7.44 36.04 2.89 22.2-16.11 22.2-16.11-9.63 23.95-11.3 36.77-5.46 77.25-5.46 80.96 6.28 5.37 10.48 4.13 16.76-7.84 18.85-7.84 8.8-4.13 9.63-5.37-.83-2.9-.83-2.9 2.93-.82 2.93-3.3-3.77-1.24-5.87-.83-14.65.41-17.6.41-5.85-1.65-5.85-3.3-.43-11.15 7.11-27.26 27.24-64.04 28.08-80.56-10.9-18.18-23.88-19.42-17.6-1.65-28.08-1.65z",
      style: {"fill":"#f8eecd","stroke":"#263238","stroke-linejoin":"round"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M50.35 185.78a30.99 30.99 0 0 0 7.78-2.58c10.52-4.96 51.85-16.11 55.84-15.02s-4.34 7.15-4.34 7.15 6.16-3.93 5.02-.72a43.34 43.34 0 0 1-2.17 5.37s-15.59 40.4-17.04 52.2L92.5 259.7m-51.42-74.36c1.18.43 2.4.69 3.66.76",
      style: {"stroke-linecap":"round","stroke":"#263238","stroke-linejoin":"round"}
    }),
    /*#__PURE__*/_createElementVNode("use", {
      "xlink:href": "#carousel-1_svg__d",
      style: {"fill":"#fff"}
    }),
    /*#__PURE__*/_createElementVNode("use", {
      "xlink:href": "#carousel-1_svg__e",
      style: {"fill":"#f8eecd"}
    }),
    /*#__PURE__*/_createElementVNode("use", {
      "xlink:href": "#carousel-1_svg__e",
      opacity: ".5",
      style: {"fill":"#fff"}
    }),
    /*#__PURE__*/_createElementVNode("use", {
      "xlink:href": "#carousel-1_svg__d",
      style: {"stroke":"#263238","stroke-linejoin":"round"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#263238",
      d: "M150.56 65.13c-.35 1.31-1.12 2.23-1.72 2.08s-.8-1.35-.45-2.65 1.13-2.23 1.73-2.07.8 1.34.44 2.64zm10.58 1.98c-.35 1.24-1.13 2.23-1.72 2.07s-.8-1.35-.45-2.65 1.13-2.23 1.72-2.07.8 1.41.45 2.65z"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M146.78 59.08s3.38-2.67 5.86-.22m7.41 2.05s3.38-2.21 4.06 2m-6.08 3.5a5.37 5.37 0 0 0-1.8 3.54c.06 1.3.53 2.54 1.34 3.55 0 0-3.14 2.48-5.84.88m-8.33.67a4.55 4.55 0 0 0 1.07 2.22 4.71 4.71 0 0 0 2.08 1.34m-19.13-27.08s.46-3.33 2.03-3.1 1.35 3.55 1.35 3.55-3.15-.45-2.03 1.33 2.51 1.11 2.51 1.11",
      style: {"stroke-linecap":"round","stroke":"#263238","stroke-linejoin":"round"}
    }),
    /*#__PURE__*/_createElementVNode("use", {
      "xlink:href": "#carousel-1_svg__f",
      style: {"fill":"#fff"}
    }),
    /*#__PURE__*/_createElementVNode("use", {
      "xlink:href": "#carousel-1_svg__f",
      style: {"stroke-linecap":"round","stroke":"#263238","stroke-linejoin":"round"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M109.73 141.73a11.66 11.66 0 0 0-3.78-2.95 11.83 11.83 0 0 0-4.66-1.2c-5.15 0-11.71 6-13.1 11.08s2.8 12 7 14.77 15-2.76 17.34-8.77-2.8-12.93-2.8-12.93z",
      style: {"fill":"#fff","stroke":"#263238","stroke-linejoin":"round"}
    }),
    /*#__PURE__*/_createElementVNode("use", {
      "xlink:href": "#carousel-1_svg__g",
      style: {"fill":"#f8eecd"}
    }),
    /*#__PURE__*/_createElementVNode("use", {
      "xlink:href": "#carousel-1_svg__g",
      opacity: ".5",
      style: {"fill":"#fff"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M179.04 120.49a18.67 18.67 0 0 1-5.63 6.47c-4.21 3.22-9.21 3.42-12.96 7.57s-12.8 20.13-21.22 23.82-15.93.47-14.06-7.43 25.77-20.32 31.85-24.48 15-9.7 18.28-9.24a4.29 4.29 0 0 1 3.74 3.29z",
      style: {"stroke":"#263238","stroke-linejoin":"round"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M179.93 112.17s-.79-3.28-3.43-4.22-5.25.47-4.77 2.12 4.06 1.24 4.77 2.82c.4.82.64 1.7.72 2.6a2.42 2.42 0 0 0 1.33-.06 2.38 2.38 0 0 0 1.09-.76c.28-.34.46-.76.51-1.2a2.33 2.33 0 0 0-.22-1.3z",
      style: {"fill":"#fff","stroke":"#263238","stroke-linejoin":"round"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "m154.22 124.18 14.51-28.17h14.52l-12.18 25.4-16.85 2.77z",
      style: {"fill":"#f8eecd","stroke":"#263238","stroke-linejoin":"round"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M179.93 112.17s-7.54-1.24-9.82 1.4a14 14 0 0 0-2.2 5.2s10.15 7.26 12.02 3.57 1.91-7.39 0-10.17z",
      style: {"fill":"#fff","stroke":"#263238","stroke-linejoin":"round"}
    }),
    /*#__PURE__*/_createElementVNode("use", {
      "xlink:href": "#carousel-1_svg__h",
      style: {"fill":"#fff"}
    }),
    /*#__PURE__*/_createElementVNode("use", {
      "xlink:href": "#carousel-1_svg__i",
      style: {"fill":"#f8eecd"}
    }),
    /*#__PURE__*/_createElementVNode("use", {
      "xlink:href": "#carousel-1_svg__i",
      opacity: ".5",
      style: {"fill":"#fff"}
    }),
    /*#__PURE__*/_createElementVNode("use", {
      "xlink:href": "#carousel-1_svg__h",
      style: {"stroke":"#263238","stroke-linejoin":"round"}
    })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<defs><path id=\"carousel-1_svg__c\" d=\"M131.74 63.68a7.84 7.84 0 0 0-4.22-7.44s-2.35 5.54-4.68 12.01c-.33.9-.67 1.74-1 2.56.9 1.9 1.98 3.7 3.23 5.38l5.36 7.32s-5.48 11.56-8.93 15.72a11.57 11.57 0 0 1-3.21 2.62c.47 1.86 1.18 3.03 2.2 2.89 3.29-.46 14.53-22.63 15.93-23.55s-4.68-11.96-4.68-17.51z\"></path><path id=\"carousel-1_svg__d\" d=\"M133.6 52.6s0-9.24-4.68-7.44-3.27 13.86-2.34 15.7a4.56 4.56 0 0 0 2.34 2.31s2.35 15.24 7.97 21.24 13.58 2.78 19.67-1.37 13.58-25.84 13.58-25.84l-10.77-12.4-4.22-13.85s-3.28-.47-1.87 1.84 2.77 12.01 2.77 12.01-6.98 9.64-22.44 7.8z\"></path><path id=\"carousel-1_svg__e\" d=\"m159.37 44.8-1.66-5.45-.1 1.24s2.06 12.6 4.54 15.44 3.77 5.69 2.51 8.94-5.35 13-11.94 16.65-9.89 4.87-14.01.81a89.51 89.51 0 0 1-7.16-8.42c1.25 3.95 3.05 8.05 5.39 10.55 5.62 6.01 13.58 2.78 19.67-1.37s13.53-26 13.53-26L159.37 44.8z\"></path><path id=\"carousel-1_svg__f\" d=\"M90.52 84.46s-9.84 2.32-13.58 6.93-2.8 19.83-.47 26.32l12.65 35.1 14.51-11.08-6.55-36.03\"></path><path id=\"carousel-1_svg__g\" d=\"M179.04 120.49a18.67 18.67 0 0 1-5.63 6.47c-4.21 3.22-9.21 3.42-12.96 7.57s-12.8 20.13-21.22 23.82-15.93.47-14.06-7.43 25.77-20.32 31.85-24.48 15-9.7 18.28-9.24a4.29 4.29 0 0 1 3.74 3.29z\"></path><path id=\"carousel-1_svg__h\" d=\"M172.47 113.11c-3.04 1.5-9.25.15-9.25.15l-5.85.54c.53-.47 1.11-.86 1.74-1.17l4.32-1.7c1.3-.65 1.08-1.93 1.08-3s-3.68.65-5.02.65-6.06 1.24-7.36 4.05a15.23 15.23 0 0 0-1.25 3.35 5.1 5.1 0 0 0-1.08 2l-1.26 8.5s-22.95 10.17-33.72 13.4c0 0-15 1.4-17.8 5.54s-3.77 11.08.47 14.78 7.95 1.39 12.18.47 46.82-29.56 46.82-29.56 7.55 0 10.78-3.72 6.56-10.16 7.02-12.94c.35-1.67-.64-1.63-1.82-1.34z\"></path><path id=\"carousel-1_svg__i\" d=\"M161.32 122.14a45.44 45.44 0 0 0-7 5.69S115.18 150.99 105.7 153a23.47 23.47 0 0 1-11.03-.06 8.95 8.95 0 0 0 2.87 7.25c4.2 3.72 7.95 1.39 12.18.47s46.83-29.56 46.83-29.56 7.54 0 10.77-3.72a36.3 36.3 0 0 0 4.45-6.6c-3.57 1.46-8.42.2-10.46 1.35z\"></path><clipPath id=\"carousel-1_svg__a\"><path d=\"M0 0h274v216H0z\" style=\"fill:#fff;\"></path></clipPath></defs>", 1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }